import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "../../../components/ui/dialog";
import { Button } from "../../../components/ui/button";
import { toast } from "sonner";

const ModalPreguntar = ({ show, onClose, onSubmit, tender }) => {
  const [question, setQuestion] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (question.trim().length < 10) {
      toast.warning("La pregunta debe tener al menos 10 caracteres.");
      return;
    }
    onSubmit(question);
    setQuestion(""); // Limpia el campo después de enviar
    onClose(); // Cierra el modal
  };

  return (
    <Dialog open={show} onOpenChange={(open) => !open && onClose()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Realiza una pregunta</DialogTitle>
        </DialogHeader>

        <p className="text-sm text-muted-foreground">
          Tu pregunta será pública y la responderá:{" "}
          {tender?.id_company ? (
            <Link
              to={`/company-profile/${tender.id_company}/${tender.company_name}`}
              className="text-primary hover:underline"
            >
              {tender.company_name}
            </Link>
          ) : (
            <Link
              to={`/profile/${tender.id_user}/${tender.user_name}-${tender.user_lastname}`}
              className="text-primary hover:underline"
            >
              {tender.user_name} {tender.user_lastname}
            </Link>
          )}
        </p>

        <form onSubmit={handleSubmit} className="mt-4 flex flex-col gap-3">
          <div>
            <label htmlFor="pregunta" className="mb-1.5 block text-sm font-medium text-foreground">
              Pregunta
            </label>
            <textarea
              id="pregunta"
              name="pregunta"
              value={question}
              onChange={(e) => setQuestion(e.target.value)}
              placeholder="Escribe tu pregunta al creador de la licitación"
              minLength={10}
              maxLength={500}
              required
              rows={4}
              className="w-full rounded-md border border-border bg-background px-3 py-2 text-sm text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary"
            />
          </div>
          <DialogFooter>
            <Button type="button" variant="outline" onClick={onClose}>
              Cancelar
            </Button>
            <Button type="submit">Enviar Pregunta</Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default ModalPreguntar;
